export default __webpack_public_path__ + "static/media/12.65592992.jpg";